//@ts-nocheck
import { PREFERENCE_BASE_URL, CRYPTO_KEY } from "./utils/constant";
import { getConfig } from "./config/config";
import loggly_util from "./loggly-util";
import util from "./util";
import { getScripInfoData } from "./Services/scripInfo";
import CryptoJS from "crypto-js";
import { getIsinNumberEquity } from "./Services/isinApiCall";
const browserName = util.getBrowserName();
var resolution = "5";
var openRate;
let lastRecdDataTime = new Date().getTime();
let lastActiveTabState = null;
let userChangedSymbol = false;
let isAutoLoading = false;
let scripInfo_cache_value = {};
let ismarketFeddFail;
const allowedDataNames = [
    'remove-drawing-tools',
    'hide-drawing-tools',
    'weakMagnet',
    'cursor'
];
let getDepthTokenPromise = null;
const { APP_BASE_API_URL, APP_OCP_APIM_KEY, APP_HEAD_KEY, APP_BASE_APIHUB_URL, APP_OCP_APIM_KEY_Marketfeed_Token, APP_BASE_PWAPROD_API_URL } = getConfig();
export const makeApiRequest = async (path, options, retries = 3, delay = 2000) => {
    for (let attempt = 0; attempt <= retries; attempt++) {
        try {
            const response = await fetch(path, options);
            if (response.status === 401 && path.startsWith("https://chartstt.5paisa.com")) {
                const newTokenData = await getTokenSingleton();
                const newAccessToken = newTokenData === null || newTokenData === void 0 ? void 0 : newTokenData.access_token;
                if (!newAccessToken) {
                    throw new Error("Token refresh failed.");
                }
                const headers = new Headers((options === null || options === void 0 ? void 0 : options.headers) || {});
                headers.set("authorization", `Bearer ${newAccessToken}`);
                options = {
                    ...options,
                    headers,
                };
                continue;
            }
            if (!response.ok) {
                const error = new Error(`HTTP error! Status: ${response.status}`);
                error.status = response.status;
                error.statusText = response.statusText;
                throw error;
            }
            return await response.json();
        }
        catch (error) {
            if (attempt === retries) {
                const finalError = new Error(`Request failed after ${retries + 1} attempts: ${error.message}`);
                finalError.status = error.status || 'N/A';
                finalError.statusText = error.statusText || 'N/A';
                throw finalError;
            }
            if (!navigator.onLine) {
                console.warn("No internet connection. Retrying in 2 seconds...");
            }
            else {
                console.warn(`API request failed (attempt ${attempt + 1}). Retrying in ${delay / 1000} seconds...`);
            }
            await new Promise((resolve) => setTimeout(resolve, delay));
        }
    }
};
export var getResolution = () => {
    return resolution;
};
export var setResolution = (reso) => {
    resolution = reso;
};
export var setTodaysOpenRate = (openRateVal) => {
    openRate = openRateVal;
};
//require for markers
export function formateDateForGetTimeScaleMarks(dateString) {
    const originalDateString = dateString;
    const originalDate = new Date(originalDateString);
    // Set the hours, minutes, and seconds to 09:30:00 AM
    originalDate.setHours(9); // Set hours to 9 AM
    originalDate.setMinutes(15); // Set minutes to 30
    originalDate.setSeconds(0); // Set seconds to 0
    // Format the updated date into a string
    const updatedDateString = originalDate.toLocaleString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
    });
    updatedDateString.replace(/,/g, "");
    return updatedDateString;
}
// return symbol
export const getSymbolName = (str) => {
    // Split the string by ':' and take the second part, then split by '/' and take the first part
    return str.split(":")[1].split("/")[0];
};
export function formatDate(date) {
    const d = new Date(date);
    let day = d.getDate();
    let month = d.getMonth() + 1; // Months are zero-based
    const year = d.getFullYear();
    // Add leading zeros to day and month if needed
    if (day < 10)
        day = "0" + day;
    if (month < 10)
        month = "0" + month;
    return `${month}/${day}/${year}`;
}
export const checkIsEmpty = (inputValue) => {
    let returnValue = false;
    // '"string" | "number" | "bigint" | "boolean" | "symbol" | "undefined" | "object" | "function"'
    if (inputValue == undefined) {
        returnValue = true;
    }
    else {
        if (typeof inputValue === "string") {
            returnValue = inputValue.length == 0;
        }
        else if (typeof inputValue === "number" ||
            typeof inputValue === "bigint") {
        }
        else if (typeof inputValue === "boolean") {
            returnValue = inputValue;
        }
        else if (typeof inputValue === "undefined") {
            returnValue = true;
        }
        else if (typeof inputValue === "object") {
            if (Array.isArray(inputValue)) {
                returnValue = inputValue.length == 0;
            }
        }
    }
    return returnValue;
};
export var getTodaysOpenRate = () => {
    return openRate;
};
export var parseFullSymbol = (fullSymbol) => {
    fullSymbol = fullSymbol.replace("-", "");
    fullSymbol = fullSymbol.replace(".", "");
    fullSymbol = fullSymbol.replace("&", "");
    const match1 = fullSymbol.match(/^(\w+):(\w+)\/(\w+)$/);
    const match2 = fullSymbol.match(/^(\w+):(\w+)$/);
    if (!match1 && !match2) {
        return null;
    }
    if (match1) {
        return {
            exchange: match1[1],
            fromSymbol: match1[2],
            toSymbol: match1[3],
        };
    }
    else if (match2) {
        return {
            exchange: match2[1],
            fromSymbol: match2[2],
            toSymbol: null,
        };
    }
};
export const uintToJson = (uintArray) => {
    const encodedString = String.fromCharCode.apply(null, Array.from(uintArray));
    const decodedString = decodeURIComponent(escape(atob(encodedString)));
    return JSON.parse(decodedString);
};
export const jsonToUint = (inputValue) => {
    const string = JSON.stringify(inputValue);
    return stringToUint(string);
};
export const stringToUint = (inputValue) => {
    const string = btoa(unescape(encodeURIComponent(inputValue)));
    const charList = string.split("");
    const uintArray = [];
    for (let i = 0; i < charList.length; i++) {
        uintArray.push(charList[i].charCodeAt(0));
    }
    return new Uint8Array(uintArray);
};
function parseJwt(token) {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64)
            .split('')
            .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join(''));
        return JSON.parse(jsonPayload);
    }
    catch (e) {
        console.error('Invalid token', e);
        return null;
    }
}
export const getTokenSingleton = async (token) => {
    let parsedJwt;
    let authKeyExpired = false;
    let authkey = null;
    if (token && token !== "undefined") {
        try {
            parsedJwt = parseJwt(token);
            token = JSON.parse(token);
            authkey = token;
            if (parsedJwt === null || parsedJwt === void 0 ? void 0 : parsedJwt.exp) {
                const currentTime = Date.now();
                const tokenExpTime = parsedJwt.exp * 1000;
                if (tokenExpTime < currentTime) {
                    authKeyExpired = true;
                }
            }
            else {
                authKeyExpired = true;
            }
        }
        catch (e) {
            console.error("Failed to parse token from localStorage:", e);
            authKeyExpired = true;
        }
    }
    if (!authkey || authKeyExpired) {
        authkey = "";
        const clientCode = localStorage.getItem("ClientCode") || "N/A";
        const chartTokenUrl = `https://dataservice.5paisa.com/TokenService/ChartToken`;
        const settings = {
            async: false,
            crossDomain: true,
            method: "POST",
            headers: {
                "ocp-apim-subscription-key": decryptEnv(APP_OCP_APIM_KEY_Marketfeed_Token),
            },
        };
        try {
            // Make direct fetch call to capture actual response status
            const response = await fetch(chartTokenUrl, settings);
            const httpStatus = response.status;
            if (!response.ok) {
                const errorText = await response.text();
                loggly_util.logAdvancedMessage("ChartToken_API_HTTP_Error", {
                    clientCode: clientCode,
                    url: chartTokenUrl,
                    statusCode: httpStatus,
                    errorType: "HTTP_Error",
                    response: errorText || response.statusText,
                    errorMessage: `HTTP ${httpStatus}: ${response.statusText}`,
                    token: localStorage.getItem("TokenResponseTv") || null,
                    timestamp: new Date().toISOString()
                });
                throw new Error(`HTTP error! Status: ${httpStatus}`);
            }
            const data = await response.json();
            if ((data.Response && data.Response === "Error") || data.length === 0) {
                // Log error response from API - using actual status code from response
                loggly_util.logAdvancedMessage("ChartToken_API_Error_Response", {
                    clientCode: clientCode,
                    url: chartTokenUrl,
                    statusCode: httpStatus,
                    errorType: "EmptyOrErrorResponse",
                    response: data.Response || "Empty data",
                    hasToken: !!(data === null || data === void 0 ? void 0 : data.access_token),
                    tokenType: (data === null || data === void 0 ? void 0 : data.token_type) || "N/A",
                    token: localStorage.getItem("TokenResponseTv") || null,
                    timestamp: new Date().toISOString()
                });
                onHistoryCallback([], {
                    noData: true,
                });
                return;
            }
            if (typeof localStorage !== "undefined") {
                localStorage.TokenResponseTv = JSON.stringify(data);
            }
            authkey = data;
        }
        catch (error) {
            // Log API failure - using actual status code if available
            loggly_util.logAdvancedMessage("ChartToken_API_Failure", {
                clientCode: clientCode,
                url: chartTokenUrl,
                errorMessage: error.message || "Unknown error",
                errorStack: error.stack || "N/A",
                statusCode: error.status || "N/A",
                token: localStorage.getItem("TokenResponseTv") || null,
                timestamp: new Date().toISOString()
            });
            // Re-throw the error to maintain existing error handling
            throw error;
        }
    }
    return authkey;
};
export var setParam = (key, value) => {
    let url = new URLSearchParams(url.search.slice(1));
    if (url.searchParams.has(key)) {
        url.searchParams.set(key, value);
    }
    else {
        url.searchParams.append(key, value);
    }
};
export var convertTime12To24 = (date, time, AMPM) => {
    var hours = Number(time.match(/^(\d+)/)[1]);
    var minutes = Number(time.match(/:(\d+)/)[1]);
    var secondes = Number(time.match(/:(\d+)/)[1]);
    if (AMPM === "PM" && hours < 12)
        hours = hours + 12;
    if (AMPM === "AM" && hours === 12)
        hours = hours - 12;
    var sHours = hours.toString();
    var sMinutes = minutes.toString();
    var sSec = secondes.toString();
    if (hours < 10)
        sHours = "0" + sHours;
    if (minutes < 10)
        sMinutes = "0" + sMinutes;
    if (secondes < 10)
        sSec = "0" + sSec;
    return date + "T" + sHours + ":" + sMinutes + ":" + sSec;
};
// export var getClientCodeDetails = (osType) => {
//   let clientCodeIOS;
//   if (osType == "iOS") {
//     clientCodeIOS = localStorage.getItem("ClientCode");
//   } else if (osType.toLowerCase() == "android") {
//     clientCodeIOS = AndroidNativeInterface.getClientCode();
//   } else {
//     clientCodeIOS = localStorage.getItem("ClientCode");
//   }
//   return clientCodeIOS;
// };
export function getCookie(name) {
    const value = document.cookie;
    // Find the cookie by name within the full cookie string
    const parts = value.split("; ").find((row) => row.startsWith(name + "="));
    if (parts) {
        // Split the cookie's key-value pair and return the value
        return parts.split("=")[1];
    }
    return null;
}
export var checkingLayoutType = (type) => {
    if (type === "s") {
        return "1";
    }
    else if (type === "2h" || type === "2v") {
        return "2";
    }
    else if (type === "3v" ||
        type === "3h" ||
        type === "3s" ||
        type === "2-1" ||
        type === "1-2" ||
        type === "3r") {
        return "3";
    }
    else if (type === "4" ||
        type === "4h" ||
        type === "4v" ||
        type === "4s" ||
        type === "1-3" ||
        type === "2-2") {
        return "4";
    }
    else if (type === "1-4" ||
        type === "5s" ||
        type === "2-3" ||
        type === "5h") {
        return "5";
    }
    else if (type === "6" || type === "6c" || type === "6h") {
        return "6";
    }
    else if (type === "7h") {
        return "7";
    }
    else if (type === "8" || type === "8c" || type === "8h") {
        return "8";
    }
};
export function parseChartUrl(url) {
    const urlParams = new URL(url).searchParams;
    const id = urlParams.get("id");
    if (!id) {
        console.error("id param is not available in the URL");
        return;
    }
    const parts = id.split("_");
    return {
        Exch: parts[0] || "",
        ExchType: parts[1] || "",
        ScripCode: parts[2] || "",
        ispopOut: urlParams === null || urlParams === void 0 ? void 0 : urlParams.get("ispopOut"),
        isTradeChart: urlParams === null || urlParams === void 0 ? void 0 : urlParams.get("isTradeChart"),
        osName: urlParams === null || urlParams === void 0 ? void 0 : urlParams.get("osName"),
        searchFlag: urlParams === null || urlParams === void 0 ? void 0 : urlParams.get("searchFlag"),
        theme: urlParams === null || urlParams === void 0 ? void 0 : urlParams.get("theme"),
    };
}
export const AlterUrlParam = async (reqInfo) => {
    let reqUrl = getExch_Exchtype_Scripcode(reqInfo);
    let finalResult = await getScripInfoData(reqUrl);
    // If contract is expired then , redirecting to nifty symbol(default)-----------------
    if (finalResult == null && !window.location.url.includes("999920000")) {
        window.location.replace(`${window.location.origin}${window.location.pathname}?id=N_C_999920000&isTradeChart=true`);
    }
    return finalResult;
};
export const changeURLparam = async (passData, isExpandIcon = false) => {
    var url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);
    // Updating only the 'id' parameter while keeping the rest unchanged
    if ((passData === null || passData === void 0 ? void 0 : passData.Exch) && (passData === null || passData === void 0 ? void 0 : passData.ExchType) && (passData === null || passData === void 0 ? void 0 : passData.ScripCode)) {
        params.set("id", `${passData.Exch}_${passData.ExchType}_${passData.ScripCode}`);
    }
    // Constructing  the updated URL
    const updatedUrl = `${url.origin}${url.pathname}?${params.toString()}`;
    if (isExpandIcon === true) {
        return updatedUrl;
    }
    window.history.pushState({}, "", updatedUrl);
    const currentUrlParams = parseChartUrl(window.location.href);
    try {
        setTimeout(function () {
            let new_ddd;
            let ddd = document
                .getElementById("tv_chart_container")
                .getElementsByTagName("iframe");
            if (ddd.length == 2) {
                new_ddd = document
                    .getElementById("tv_chart_container")
                    .getElementsByTagName("iframe")[1]
                    .contentDocument.getElementsByTagName("body")[0]
                    .querySelector(".dateRangeExpanded-BXXUwft2");
            }
            else {
                new_ddd = document
                    .getElementById("tv_chart_container")
                    .getElementsByTagName("iframe")[0]
                    .contentDocument.getElementsByTagName("body")[0]
                    .querySelector(".dateRangeExpanded-BXXUwft2");
            }
            let reqDivs = new_ddd.querySelectorAll("div")[0].querySelectorAll("button");
            reqDivs.forEach((div) => {
                const btnArray = ["1Y", "5Y", "Max"];
                if ((currentUrlParams === null || currentUrlParams === void 0 ? void 0 : currentUrlParams.ExchType) != "C") {
                    if ((div === null || div === void 0 ? void 0 : div.ariaLabel) && btnArray.includes(div === null || div === void 0 ? void 0 : div.ariaLabel)) {
                        div.style.display = "none";
                    }
                }
                else {
                    div.style.display = "block";
                }
            });
        }, 1000);
    }
    catch (error) {
        console.log(error);
    }
};
export async function getSellAuthStatus() {
    var _a;
    let orderdata = JSON.parse(localStorage.getItem(localStorage.getItem("ClientCode") + "-order"));
    let data = orderdata.symbol.split("/");
    let ExchType = data[1].split("-")[1];
    let scripCode = data[1].split("-")[0];
    let exchange;
    if (data[0].split(":")[0] == "BSE") {
        exchange = "B";
    }
    else if (data[0].split(":")[0] == "NSE") {
        exchange = "N";
    }
    else if (data[0].split(":")[0] == "M" || data[0].split(":")[0] == "MCX") {
        exchange = "M";
    }
    else if (data[0].split(":")[0] == "U") {
        exchange = "U";
    }
    let res = await fetch(
    //`${APP_BASE_API_URL}tradeapi/GetSellAuthorizationStatus`,
    `${APP_BASE_APIHUB_URL}GetSellAuthorizationStatus`, {
        method: "POST",
        credentials: "include",
        headers: {
            Authorization: `Bearer ${(_a = localStorage
                .getItem("JWTToken")) === null || _a === void 0 ? void 0 : _a.replace("JWTToken", "")} `,
            clientid: "NTA4OTU3NTk=",
            "ocp-apim-subscription-key": decryptEnv(APP_OCP_APIM_KEY),
            "content-type": "application/json",
            // userid:APP_USER_ID,
            // password:APP_PASSWORD,
        },
        body: JSON.stringify({
            head: {
                appName: "5PTRADE",
                appSource: "09",
                appVer: "1.0",
                osName: "Web",
                key: decryptEnv(APP_HEAD_KEY),
                requestCode: "5PGetSellAuthorizationStatus",
            },
            body: {
                ClientCode: localStorage.getItem("ClientCode"),
                GetSellAuthorizationStatusReqList: [
                    {
                        ExchType: ExchType,
                        Exch: exchange,
                        ScripCode: scripCode,
                        Qty: orderdata.qty,
                    },
                ],
            },
        }),
    });
    const authStatus = await res.json();
    return authStatus;
}
export const getPreferenceApi = async (clientCode, reqUrl) => {
    const url = `${PREFERENCE_BASE_URL}${clientCode}`;
    const headers = {
        "Ocp-apim-subscription-key": decryptEnv(APP_OCP_APIM_KEY),
        "content-type": "application/json",
    };
    const requestOptions = {
        method: "GET",
        headers: headers,
        credentials: "include",
        redirect: "follow",
    };
    try {
        const response = await fetch(url, requestOptions);
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }
        return response.json();
    }
    catch (error) {
        console.error("There was a problem with the fetch operation:", error);
        throw error;
    }
};
export const setPreferenceApi = async (prefData, clientCode) => {
    const url = `${PREFERENCE_BASE_URL}${clientCode}`;
    const headers = {
        "Ocp-apim-subscription-key": decryptEnv(APP_OCP_APIM_KEY),
        "content-type": "application/json",
    };
    const body = {
        chart: {
            themeVal: prefData.themeVal,
            productVal: prefData.productVal,
            defaultClose: prefData.defaultClose,
        },
    };
    const requestOptions = {
        method: "POST",
        credentials: "include",
        headers: headers,
        redirect: "follow",
        body: JSON.stringify(body),
    };
    await fetch(url, requestOptions);
};
export const deleteThemeCookieAndSetNewCookie = (newTheme) => {
    const myHeaders = new Headers();
    myHeaders.append("authorization", "CC4AF799EE1DEC6E648F6C2B4DDB1");
    myHeaders.append("content-type", "application/json");
    const raw = JSON.stringify({
        CookieName: "theme",
    });
    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
    };
    fetch(`${APP_BASE_PWAPROD_API_URL}DeleteCookie`, requestOptions)
        .then((response) => {
        if (!response.ok) {
            throw new Error(`Error: ${response.status}`);
        }
        return response.json();
    })
        .then((result) => {
        // Set a new cookie if the API call is successful
        const date = new Date();
        date.setFullYear(date.getFullYear() + 100); // 100 years in the future
        const expires = "expires=" + date.toUTCString();
        document.cookie = `theme=${newTheme}; ${expires}; path=/; domain=.5paisa.com;`;
    })
        .catch((error) => {
        console.error("API call failed. No new cookie set:", error);
    });
};
export let captureEvent = (EventName, property) => {
    window.clevertap.event.push(EventName, property);
};
export const getExch_Exchtype_Scripcode = (input) => {
    const [exch, rest] = input.split(":");
    const lastDashIndex = rest.lastIndexOf("-");
    const fullSymbol = rest.substring(0, lastDashIndex);
    const [symbolNamefromticker, leftover] = fullSymbol.split("/");
    // const symbol = symbolNamefromticker.split(" ")[1];
    const symbol = rest.split("/")[0];
    const ExchType = rest.substring(lastDashIndex + 1);
    const ScripCode = fullSymbol.split("/")[1];
    const Exch = exch[0];
    return {
        Exch,
        ScripCode,
        ExchType,
        symbol,
    };
};
export const get_New_Symbol = (input) => {
    const parts = input.split(":");
    const exchangeCode = parts[0];
    const details = parts[1].split("/");
    const name = details[0];
    const scripCode = details[1];
    const scripType = details[3];
    let exchange;
    switch (exchangeCode) {
        case "N":
        case "NSE":
            exchange = "NSE";
            break;
        case "B":
        case "BSE":
            exchange = "BSE";
            break;
        case "M":
        case "MCX":
            exchange = "MCX";
            break;
        default:
            exchange = "NSE";
    }
    return `${exchange}:${name}/${scripCode}-${scripType}`;
};
export const unsubscribeExch_Exchtype_Scripcode = (input) => {
    const [exch, rest] = input.split(":");
    const [name, remaining] = rest.split("/");
    const [scripCode, restWithAdditional] = remaining.split("-");
    const [exchType, additional] = restWithAdditional.split("_#_");
    const exchangeFirstLetter = exch[0];
    return {
        exchangeFirstLetter,
        scripCode,
        exchType,
    };
};
export const checkTimeDiff = () => {
    let urlParams = parseChartUrl(window.location.href);
    const currentTime = new Date().getTime();
    let differenceInMillis = currentTime - lastRecdDataTime;
    // differenceInMinutes = differenceInMillis / (1000 * 60);
    // Don't auto-load if user recently changed symbol manually
    if (differenceInMillis >= 60000 && !userChangedSymbol) {
        isAutoLoading = true;
        if (sessionStorage.getItem("__cInternal") === "true") {
            const getAutoSaveData = JSON.parse(localStorage.getItem("onAutoSaveNeededData"));
            try {
                window.tvWidget.load(getAutoSaveData);
            }
            catch (error) {
                console.error("Error loading auto-save data from session:", error);
            }
        }
        else {
            const getAutoSaveData = sessionStorage.getItem("autoSaveStorageMultiLayout_Tradechart") != null
                ? JSON.parse(sessionStorage.getItem("autoSaveStorageMultiLayout_Tradechart"))
                : JSON.parse(sessionStorage.getItem("autoSaveStorage_Tradechart" + (urlParams === null || urlParams === void 0 ? void 0 : urlParams.ScripCode)));
            window.tvWidget.load(getAutoSaveData);
        }
        setTimeout(() => {
            isAutoLoading = false;
        }, 1000);
    }
    lastRecdDataTime = currentTime;
};
// Function when user manually changes symbol
export const onSymbolChange = () => {
    // Only set the flag if we're not in the middle of auto-loading
    if (!isAutoLoading) {
        userChangedSymbol = true;
        // Reset the flag after 5 seconds to allow load again if needed
        setTimeout(() => {
            userChangedSymbol = false;
        }, 5000);
    }
};
export const sortPreviousSymbols = (previousSymbolsList) => {
    // Extract symbols only once and pair them with their original strings
    const symbolPairs = previousSymbolsList.map((symbolString) => ({
        original: symbolString,
        symbol: symbolString.split(":")[1].split("/")[0],
    }));
    // Check if the list is in ascending order
    const isAscending = symbolPairs[0].symbol < symbolPairs[1].symbol;
    // Sort the list in the opposite order
    symbolPairs.sort((a, b) => {
        return isAscending
            ? b.symbol.localeCompare(a.symbol)
            : a.symbol.localeCompare(b.symbol);
    });
    // Extract the sorted original strings
    return symbolPairs.map((pair) => pair.original);
};
export const filterIsEditable = (watchdef, name) => {
    let returnValue;
    for (let i = 0; i < watchdef.length; i++) {
        if (watchdef[i].MwatchName == name) {
            returnValue = watchdef[i].CanEditOrDelete;
            return returnValue;
        }
    }
};
export const getDepthToken = async (key) => {
    if (!getDepthTokenPromise) {
        getDepthTokenPromise = getTokenForDepth(key);
    }
    return getDepthTokenPromise;
};
const getTokenForDepth = async (token) => {
    if (token && token !== "undefined") {
        token = JSON.parse(token);
    }
    let authKeyExpired = false;
    if (token && token !== "undefined") {
        authkey = token;
        if (new Date(parseInt(authkey.expires_in) * 1000) < new Date()) {
            authKeyExpired = true;
        }
    }
    if (!authkey || authKeyExpired) {
        var authkey = "";
        var settings = {
            async: false,
            crossDomain: true,
            method: "POST",
            headers: {
                "ocp-apim-subscription-key": decryptEnv(APP_OCP_APIM_KEY_Marketfeed_Token),
            },
        };
        const data = await makeApiRequest(`https://dataservice.5paisa.com/TokenService/Marketfeed-Token`, settings);
        if ((data.Response && data.Response === "Error") || data.length === 0) {
            onHistoryCallback([], {
                noData: true,
            });
            return;
        }
        if (typeof localStorage !== "undefined") {
            localStorage.setItem("DepthTokenResponseTv", JSON.stringify(data));
        }
        authkey = data;
    }
    return authkey;
};
export const convertToEpochIST = (dateString) => {
    // Regular expression to extract the timestamp and the offset
    const regex = /\/Date\((\d+)([+-]\d{4})\)\//;
    const match = dateString.match(regex);
    if (!match) {
        console.error("Invalid date format");
        return null;
    }
    // Extract timestamp and offset from the matched groups
    const timestamp = parseInt(match[1], 10);
    const offset = match[2];
    // Convert offset to minutes
    const offsetSign = offset[0] === "+" ? 1 : -1;
    const offsetHours = parseInt(offset.slice(1, 3), 10);
    const offsetMinutes = parseInt(offset.slice(3, 5), 10);
    const totalOffsetMinutes = offsetSign * (offsetHours * 60 + offsetMinutes);
    // Adjust timestamp to UTC
    const utcTimestamp = timestamp - totalOffsetMinutes * 60 * 1000;
    // IST offset in minutes (IST is UTC+5:30)
    const istOffsetMinutes = 330; // 5 * 60 + 30
    // Convert UTC time to IST
    const istTimestamp = utcTimestamp + istOffsetMinutes * 60 * 1000;
    // Create a Date object for the IST time
    const istDate = new Date(istTimestamp);
    // Set the seconds to 00
    istDate.setSeconds(0, 0);
    // Return the epoch time in IST with seconds set to 00
    return istDate.getTime();
};
export const sortDataforDepth = (data) => {
    let askPrice = [];
    let bidPrice = [];
    for (let i = 0; i < data.length; i++) {
        const obj = { price: data[i].Price, volume: data[i].Quantity };
        if (data[i].BbBuySellFlag === 66) {
            bidPrice.push(obj);
        }
        else {
            askPrice.push(obj);
        }
    }
    return { askPrice, bidPrice };
};
export const openCustomAlert = (message) => {
    var overlay = document.getElementById("notification-custom-alert-overlay");
    var alertMessage = document.getElementById("notification-custom-alert-message");
    var okButton = document.getElementById("notification-custom-alert-ok");
    alertMessage.innerText = message;
    okButton.onclick = function () {
        overlay.style.display = "none";
    };
    overlay.style.display = "flex";
};
export const findMissingValues = (a, b) => {
    const missingValues = a.filter((value) => !b.includes(value));
    return missingValues;
};
export const saveMW = async (watchlistAction, WatchListname, Watch_exchange, Watch_Scripcode, Watch_Exchtype) => {
    try {
        const myHeaders = new Headers();
        myHeaders.append("Ocp-apim-subscription-key", decryptEnv(APP_OCP_APIM_KEY));
        myHeaders.append("content-type", "application/json");
        // myHeaders.append("userid", APP_USER_ID);
        // myHeaders.append("Password", APP_PASSWORD);
        const raw = JSON.stringify({
            head: {
                appName: "5PTRADE",
                appSource: "09",
                appVer: "1.0",
                key: decryptEnv(APP_HEAD_KEY),
                osName: "Web",
                requestCode: "5PSaveMWV1",
            },
            body: {
                Clientcode: localStorage.getItem("ClientCode"),
                MWname: WatchListname,
                ClientLoginType: 1,
                Data: [
                    {
                        Exch: Watch_exchange,
                        ExchType: Watch_Exchtype,
                        ScripCode: Watch_Scripcode,
                        Action: watchlistAction,
                    },
                ],
            },
        });
        const requestOptions = {
            method: "POST",
            credentials: "include",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };
        const response = await fetch(`${APP_BASE_API_URL}tradeapi/SaveMW`, requestOptions);
        if (!response.ok) {
            throw new Error(`Request failed with status ${response.status}`);
        }
        const result = await response.text();
    }
    catch (error) {
        console.error("Error:", error.message);
    }
};
/// Netposition Tab Call function Button Observer
export const Alltab = (firstTab, brokerFac) => {
    let activeTab = "positions"; // Start with "positions" as the active tab
    // Function to handle tab switching
    function handleTabClick(newTab) {
        if (newTab !== activeTab) {
            if (newTab === "positions") {
                brokerFac.positions(); // Trigger brokerFac.positions() only when switching to the Positions tab
            }
            if (newTab === "holdings") {
                brokerFac.fetchHoldingsData();
            }
            activeTab = newTab;
        }
    }
    // Function to retrieve the tab element by index
    function getTabElement(index, firstTab) {
        if (firstTab === "Collapse panel") {
            const tabElement = document
                .getElementById("tv_chart_container")
                .getElementsByTagName("iframe")[0]
                .contentDocument.getElementsByTagName("body")[0]
                .getElementsByTagName("div")[2]
                .getElementsByClassName("layout__area--bottom")[0]
                .getElementsByClassName("topPanel-vCXUCd2i")[0]
                .getElementsByTagName("div")[0].childNodes[0].childNodes[index];
            return tabElement || null; // Return null if the element is not found
        }
        else {
            const tabElement = document
                .getElementById("tv_chart_container")
                .getElementsByTagName("iframe")[0]
                .contentDocument.getElementsByTagName("body")[0]
                .getElementsByTagName("div")[2]
                .getElementsByClassName("layout__area--bottom")[0]
                .getElementsByClassName("topPanel-vCXUCd2i")[0]
                .getElementsByTagName("div")[0].childNodes[0].childNodes[index];
            return tabElement || null; // Return null if the element is not found
        }
    }
    // Retrieve and cache tab elements
    const positionTab = getTabElement(0, firstTab);
    const ordersTab = getTabElement(1, firstTab);
    const accountSummaryTab = getTabElement(2, firstTab);
    const holdingsTab = getTabElement(3, firstTab);
    const closedPositionsTab = getTabElement(4, firstTab);
    // Ensure the elements are found before adding event listeners
    if (positionTab) {
        positionTab.addEventListener("click", () => handleTabClick("positions"));
    }
    if (ordersTab) {
        ordersTab.addEventListener("click", () => handleTabClick("orders"));
    }
    if (accountSummaryTab) {
        accountSummaryTab.addEventListener("click", () => handleTabClick("accountsummary"));
    }
    if (holdingsTab) {
        holdingsTab.addEventListener("click", () => handleTabClick("holdings"));
    }
    if (closedPositionsTab) {
        closedPositionsTab.addEventListener("click", () => handleTabClick("closed_positions"));
    }
};
export const observeTabChanges = (brokerFac) => {
    // Helper function to safely get the target node
    const getTargetNode = () => {
        try {
            return document
                .getElementById("tv_chart_container")
                .getElementsByTagName("iframe")[0]
                .contentDocument.getElementsByTagName("body")[0]
                .getElementsByTagName("div")[2]
                .getElementsByClassName("layout__area--bottom")[0]
                .childNodes[0].childNodes[0].getElementsByClassName("buttons-dA6R3Y1X")[0].children[0];
        }
        catch (e) {
            // Log the error and return null if the node is not found
            console.error("Failed to find target node:", e);
            return null;
        }
    };
    // Function to observe changes on the target node
    const setupObserver = (targetNode) => {
        // Check the initial state
        const initialTabName = targetNode.getAttribute("aria-label");
        if (initialTabName === "Collapse panel" &&
            lastActiveTabState !== initialTabName) {
            Alltab(initialTabName, brokerFac);
            lastActiveTabState = initialTabName; // Update last active state
        }
        // Create an observer instance linked to the callback function
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === "aria-label") {
                    const tabName = mutation.target.getAttribute("aria-label");
                    if (tabName === "Collapse panel" && lastActiveTabState !== tabName) {
                        setTimeout(() => Alltab(undefined, brokerFac), 2000); // Delay to ensure tab elements are available
                        lastActiveTabState = tabName; // Update last active state
                    }
                }
            });
        });
        // Configuration for the observer
        const config = { attributes: true };
        // Start observing the target node
        observer.observe(targetNode, config);
    };
    // Function to wait for the iframe to load and initialize the observer
    const waitForIframeAndObserve = () => {
        var _a, _b;
        const iframe = (_a = document
            .getElementById("tv_chart_container")) === null || _a === void 0 ? void 0 : _a.getElementsByTagName("iframe")[0];
        if (iframe && ((_b = iframe.contentDocument) === null || _b === void 0 ? void 0 : _b.readyState) === "complete") {
            const targetNode = getTargetNode();
            if (targetNode) {
                setupObserver(targetNode); // Start observing when the target node is found
            }
            else {
                console.warn("Target node not found. Retrying...");
                setTimeout(waitForIframeAndObserve, 500); // Retry every 500ms
            }
        }
        else {
            console.warn("Iframe not yet loaded. Retrying...");
            setTimeout(waitForIframeAndObserve, 500); // Retry every 500ms
        }
    };
    // Start the iframe load watcher
    waitForIframeAndObserve();
};
export const objectForOrderForm = async (buySellFlag, isLimitOrder, askprice_val) => {
    let newUrlParam = new URL(window.location).searchParams;
    let name = `${newUrlParam.get("symbol")}`;
    if (newUrlParam.get("type") !== "overview") {
        name += ` ${newUrlParam.get("expiry_date")}`;
        if (newUrlParam.has("option_type")) {
            name += ` ${newUrlParam.get("option_type")}`;
        }
        if (newUrlParam.has("strike_price")) {
            name += ` ${newUrlParam.get("strike_price").replaceAll(".00", "")}`;
        }
    }
    var myObj = {
        isBuy: buySellFlag,
        name: name,
        exchange: newUrlParam.has("exchange")
            ? newUrlParam.get("exchange").split("")[0].toUpperCase()
            : newUrlParam.get("exch").split("")[0].toUpperCase(),
        exchangeType: newUrlParam.get("exchType"),
        scripCode: newUrlParam.get("scripCode"),
        lastTradePrice: JSON.parse(localStorage.getItem("lastRate")).LastRate,
        previousClose: JSON.parse(localStorage.getItem("lastRate")).previousClose,
        isBasket: false,
        openedFrom: "chart",
        orderFor: "P",
    };
    if (isLimitOrder) {
        const orderData = {
            AHProcess: "N",
            AfterHours: "N",
            AtMarket: "N",
            BrokerOrderId: 0,
            BuySell: buySellFlag ? "B" : "S",
            DelvIntra: "",
            DisClosedQty: 0,
            Exch: newUrlParam.has("exchange")
                ? newUrlParam.get("exchange").split("")[0].toUpperCase()
                : newUrlParam.get("exch").split("")[0].toUpperCase(),
            ExchOrderID: 0,
            ExchType: newUrlParam.get("exchType"),
            MarketLot: 0,
            OrderID: 0,
            OrderStatus: "",
            OrderValidUpto: "",
            OrderValidity: 0,
            PendingQty: 0,
            Qty: 0,
            Rate: askprice_val ? parseFloat(askprice_val) : 0,
            SLTriggerRate: 0,
            SMOProfitRate: 0,
            SMOSLLimitRate: 0,
            SMOSLTriggerRate: 0,
            SMOTrailingSL: 0,
            StopLossPrice: 0,
            TradedQty: 0,
            WithSL: "N",
        };
        myObj.orderData = orderData;
    }
    return myObj;
};
export const orderObjectUtilityFunction = async (obj) => {
    if (browserName != "FIREFOX") {
        window.parent.postMessage(obj, window.location.ancestorOrigins[0]);
    }
    else {
        try {
            function getAncestorOrigins() {
                const urls = [];
                let parentWin = window;
                while (parentWin !== window.top) {
                    if (parentWin.document.referrer) {
                        try {
                            const url = new URL(parentWin.document.referrer);
                            urls.push(url.origin);
                        }
                        catch (e) { }
                    }
                    parentWin = parentWin.parent;
                }
                return urls;
            }
            let pp = getAncestorOrigins();
            window.parent.postMessage(obj, pp[0]);
        }
        catch (error) {
            console.error('Error accessing parent window location:', error);
        }
    }
};
export const arrayToCommaString = (array) => {
    return array.join(",");
};
export function generateScrip(ticker) {
    let match = ticker.match(/(NSE|BSE|MCX):([A-Z]+) (\d{2}) (\w{3}) (\d{4})(?: (PE|CE) (\d+))?/);
    if (match) {
        let name = match[2];
        let day = match[3];
        let month = match[4];
        let year = match[5];
        let optionType = match[6];
        let price = match[7];
        let date = `${day}-${month.toUpperCase()}-${year.slice(-2)}`;
        if (optionType && price) {
            return `${name}~O:${date}:${optionType}:${price}`;
        }
        else {
            return `${name}~F:${date}`;
        }
    }
    return null;
}
export const arrayToSemicolonString = (array) => {
    return array.join(";");
};
export const getMaxDate = async (dateNum) => {
    if (dateNum == null || isNaN(dateNum))
        return;
    var year = +dateNum.toString().substr(0, 4), month = +dateNum.toString().substr(4);
    return new Date(year, month, 0);
};
export const getTransactionDetails = async (symbolInfo, startDate, endDate) => {
    let keyTransactions = `${symbolInfo.exchType}-${symbolInfo.exchange}`;
    let isinNumber = "";
    let transactionType = "";
    let generatedScrip = "";
    switch (keyTransactions) {
        case "D-M":
        case "D-MCX":
            isinNumber = generateScrip(symbolInfo.ticker);
            transactionType = "CommodityTransactions";
            break;
        case "D-B":
        case "D-BSE":
        case "D-N":
        case "D-NSE":
            generatedScrip = generateScrip(symbolInfo.ticker);
            transactionType = "DerivativesTransactions";
            break;
        case "C-B":
        case "C-BSE":
        case "C-N":
        case "C-NSE":
            isinNumber = await getIsinNumberEquity(symbolInfo, startDate, endDate);
            transactionType = "EquityTransactions";
            break;
        case "U-N":
        case "U-NSE":
            isinNumber = generateScrip(symbolInfo.ticker);
            transactionType = "CurrencyDerivativesTransactions";
            break;
        default:
            transactionType = "Unknown";
            break;
    }
    return { isinNumber, generatedScrip, transactionType };
};
export const convertTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(date.getUTCSeconds()).padStart(2, '0');
    return `${year}${month}${day}${hours}${minutes}${seconds}`;
};
export const hexToAscii = (token) => {
    const hex = token ? token.toString() : '';
    let str = '';
    for (let n = 0; n < hex.length; n += 2) {
        str += String.fromCharCode(parseInt(hex.substr(n, 2), 16));
    }
    return str;
};
export const getType = (exchType) => {
    var dividerValue = 100;
    if (exchType === "U") {
        dividerValue = 10000; //crore
    }
    return dividerValue;
};
export function extractParams(param, expiryDate, optionType, strikePrice) {
    if (param.has("expiry_date")) {
        expiryDate = param.get("expiry_date");
    }
    if (param.has("option_type") && param.has("strike_price")) {
        optionType = param.get("option_type");
        strikePrice = parseInt(param.get("strike_price"));
    }
    return { expiryDate, optionType, strikePrice };
}
export const adjustYear = async (inputDate) => {
    let date = new Date(inputDate); // Convert input string to Date object
    if (date.getFullYear() < 1989) {
        date.setFullYear(1989); // Update the year to 1989
    }
    // Format the date back to YYYY-MM-DD
    return date.toISOString().split("T")[0];
};
export function createFnoButton({ text, title, url, classNameIcon, themeVal }) {
    const button = window.tvWidget.createButton({ align: "right" });
    button.setAttribute("title", title);
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("width", "15");
    svg.setAttribute("height", "16");
    svg.setAttribute("viewBox", "0 0 15 16");
    svg.setAttribute("fill", "none");
    const paths = [
        {
            d: "M2.45175 2.52166L13 7.67608L2.45175 12.8305C2.39154 12.8536 2.32582 12.8584 2.26291 12.8441C2.20001 12.8298 2.14277 12.7971 2.09846 12.7503C2.05286 12.7021 2.02146 12.6423 2.00776 12.5775C1.99405 12.5126 1.99857 12.4452 2.02082 12.3827L3.61774 7.67608L2.02082 2.96942C1.99857 2.90697 1.99405 2.83957 2.00776 2.7747C2.02146 2.70983 2.05286 2.65002 2.09846 2.6019C2.14277 2.55502 2.20001 2.52237 2.26291 2.50808C2.32582 2.4938 2.39154 2.49852 2.45175 2.52166Z",
            stroke: "#1D2939",
        },
        {
            d: "M3.6178 7.6759H13",
            stroke: "#1D2939",
        },
    ];
    paths.forEach(({ d, stroke }) => {
        const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path.setAttribute("d", d);
        path.setAttribute("stroke", stroke);
        path.setAttribute("stroke-linecap", "round");
        path.setAttribute("stroke-linejoin", "round");
        svg.appendChild(path);
    });
    const textShowWrapper = document.createElement("div");
    textShowWrapper.classList.add("text-show-wrapper");
    const exploreSpan = document.createElement("span");
    exploreSpan.innerText = "Explore";
    textShowWrapper.appendChild(exploreSpan);
    const buttonText = document.createElement("span");
    buttonText.innerText = text;
    button.appendChild(textShowWrapper);
    button.appendChild(svg);
    button.appendChild(buttonText);
    const isDarkTheme = themeVal === "night" || themeVal === "dark";
    const iconClass = isDarkTheme ? `${classNameIcon}Dark` : classNameIcon;
    button.classList.add(iconClass);
    if (isDarkTheme) {
        svg.querySelectorAll("path").forEach((path) => path.setAttribute("stroke", "#2962FF"));
    }
    button.addEventListener("click", () => window.open(url, "_blank", "noopener,noreferrer"));
    return button;
}
export const getBase64DecryptedAccessList = (encryptedValue) => {
    const decodedUtf8String = CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(encryptedValue));
    return JSON.parse(decodedUtf8String);
};
export const getDataFromLocal = (key) => {
    const value = localStorage.getItem(key);
    return value !== null ? JSON.parse(value) : null;
};
//Hide CWA Dashboard for drawing tools
export function observeTradingViewMenuAndToggleDashboard() {
    function shouldShowDashboard(tvDoc) {
        const menu = tvDoc.querySelector('.menuWrap-Kq3ruQo8');
        if (!menu)
            return true;
        const menuItems = menu.querySelectorAll('[data-role="menuitem"]');
        for (let i = 0; i < menuItems.length; i++) {
            const dataName = menuItems[i].getAttribute('data-name');
            if (dataName && allowedDataNames.includes(dataName)) {
                return true;
            }
        }
        return false;
    }
    function setupObserver() {
        var _a;
        const tvIframe = (_a = document.getElementById('tv_chart_container')) === null || _a === void 0 ? void 0 : _a.querySelector('iframe');
        const dashboard = document.getElementById('cwa2sigma-dashboard');
        if (!tvIframe || !tvIframe.contentDocument || !dashboard) {
            setTimeout(setupObserver, 500);
            return;
        }
        const tvDoc = tvIframe.contentDocument;
        const observer = new (tvIframe.contentWindow.MutationObserver)(function () {
            if (shouldShowDashboard(tvDoc)) {
                dashboard.style.display = '';
            }
            else {
                dashboard.style.display = 'none';
            }
        });
        observer.observe(tvDoc.body, { childList: true, subtree: true });
        if (shouldShowDashboard(tvDoc)) {
            dashboard.style.display = '';
        }
        else {
            dashboard.style.display = 'none';
        }
    }
    setupObserver();
}
export const extractSymbolParts = (symbol) => {
    const [exchangeSegment, rest] = symbol.split(':');
    const [nameAndDate, scripCodeWithType] = rest.split('/');
    const [scripCodeStr, exchangeType] = scripCodeWithType.split('-');
    const stockName = nameAndDate
        .replace(/\d{1,2} [A-Z]{3} \d{4}/, '')
        .replace(/\b(CE|PE)\b/, '')
        .replace(/(\d+\.\d{2})/, '')
        .trim();
    const exChange = exchangeSegment[0];
    const scripCode = Number(scripCodeStr);
    const dateMatch = nameAndDate.match(/\d{1,2} [A-Z]{3} \d{4}/);
    const date = dateMatch ? dateMatch[0] : null;
    const optionTypeMatch = nameAndDate.match(/\b(CE|PE)\b/);
    const optionType = optionTypeMatch ? optionTypeMatch[0] : null;
    const strikePriceMatch = nameAndDate.match(/(\d+\.\d{2})/);
    const strikePrice = strikePriceMatch ? parseFloat(strikePriceMatch[1]) : null;
    return {
        exChange,
        exchangeType,
        scripCode,
        stockName,
        date,
        optionType,
        strikePrice,
    };
};
export const sortDataformarketDepth = (data) => {
    let askPrice = [];
    let bidPrice = [];
    let tBidQ = data.TBidQ || 0; // Get TBidQ from the data object
    let tOffQ = data.TOffQ || 0; // Get TOffQ from the data object
    // Assuming the actual market depth data is in data.Details array
    const details = data.Details || [];
    for (let i = 0; i < details.length; i++) {
        const obj = {
            price: details[i].Price,
            volume: details[i].Quantity,
            order: details[i].NumberOfOrders
        };
        if (details[i].BbBuySellFlag === 66) {
            bidPrice.push(obj);
        }
        else {
            askPrice.push(obj);
        }
    }
    return {
        askPrice,
        bidPrice,
        tBidQ,
        tOffQ
    };
};
export const getStockType = (symbol) => {
    if (!symbol)
        return '';
    const scripCodeParts = symbol.split("/");
    if (scripCodeParts.length > 1) {
        const scripCode = scripCodeParts[1].split("-")[0];
        if (scripCode && sessionStorage.getItem(`isIndice${scripCode}`) === "Y") {
            return 'index';
        }
    }
    if (symbol.endsWith('-C')) {
        return 'cash';
    }
    const exchange = symbol.substring(0, 3);
    switch (exchange) {
        case 'MCX':
            return symbol.includes(' CE ') || symbol.includes(' PE ')
                ? 'commodity_opt'
                : 'commodity_fut';
        case 'NSE':
        case 'BSE':
            if (/\b(CE|PE)\b/.test(symbol)) {
                return 'option';
            }
            if (/\d{1,2} [A-Z]{3} \d{4}/.test(symbol)) {
                return 'future';
            }
            return '';
        default:
            return '';
    }
};
export function bringToFront(element) {
    window.__popupZIndex += 1;
    element.style.zIndex = window.__popupZIndex;
}
// for VAPT key decrytion
export const decryptEnv = (encrypted) => {
    if (!encrypted)
        return "";
    try {
        const bytes = CryptoJS.AES.decrypt(encrypted, CRYPTO_KEY);
        const decrypted = bytes.toString(CryptoJS.enc.Utf8);
        if (!decrypted)
            throw new Error("Invalid encrypted value");
        return decrypted;
    }
    catch (err) {
        console.error("Env decrypt error:", err);
        return "";
    }
};
export const updateMainSeries = (obj, symbol, name, index) => {
    var _a, _b;
    const panes = (_b = (_a = obj === null || obj === void 0 ? void 0 : obj.charts) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.panes;
    if (!panes)
        return obj;
    const mainPane = panes.find(p => { var _a, _b; return ((_b = (_a = p === null || p === void 0 ? void 0 : p.sources) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.type) === "MainSeries"; });
    if (!mainPane)
        return obj;
    const state = mainPane.sources[0].state;
    state.symbol = symbol;
    state.shortName = name;
    return obj;
};
function bytesToWordArray(u8) {
    const words = [];
    for (let i = 0; i < u8.length; i++) {
        const wordIndex = i >>> 2;
        if (words[wordIndex] === undefined) {
            words[wordIndex] = 0;
        }
        words[wordIndex] |= (u8[i] & 0xff) << (24 - (i % 4) * 8);
    }
    return CryptoJS.lib.WordArray.create(words, u8.length);
}
function csvToBytes(csv) {
    return csv.split(",").map(s => {
        let value = parseInt(s.trim(), 10);
        if (value > 127 || value < -128) {
            value = value - 256;
        }
        let signed8 = value;
        if (signed8 > 127) {
            signed8 = signed8 - 256;
        }
        else if (signed8 < -128) {
            signed8 = signed8 + 256;
        }
        return signed8 < 0 ? signed8 + 256 : signed8;
    });
}
export function decryptAES(encryptedText) {
    const keyString = "132,42,53,124,75,56,87,38,9,10,161,132,183,91,105,16,117,218,149,230,221,212,235,64";
    const ivString = "83,71,26,58,54,35,22,11,83,71,26,58,54,35,22,11";
    const keyBytes = csvToBytes(keyString); // 24 bytes => AES-192
    const ivBytes = csvToBytes(ivString); // 16 bytes
    const key = bytesToWordArray(keyBytes);
    const iv = bytesToWordArray(ivBytes);
    const cipherParams = CryptoJS.lib.CipherParams.create({
        ciphertext: CryptoJS.enc.Base64.parse(encryptedText),
    });
    const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    return CryptoJS.enc.Utf8.stringify(decrypted);
}
export function getExactParam(name) {
    var _a;
    const rawUrl = window.location.href;
    const value = ((_a = rawUrl.split(name + "=")[1]) === null || _a === void 0 ? void 0 : _a.split("&")[0]) || "";
    return decodeURIComponent(value);
}
export const extractUnixMsBroker = (dotNetDate) => {
    if (typeof dotNetDate !== "string")
        return null;
    const match = dotNetDate.match(/^\/Date\((-?\d+)/);
    return match ? Number(match[1]) : null;
};
